module.exports = Object.assign(
  require('./basic'),
  require('./util'),
  require('./coc')
)